import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'naturalSort',
    standalone: true,
})
export class NaturalSortPipe implements PipeTransform {
    public transform<Item>(items: Item[] | null, key: KeysOfType<Item, string>): Item[] {
        if (!items) return [];

        const sortByKey = (a: Item, b: Item) => {
            const aValue = a[key] as string;
            const bValue = b[key] as string;

            return aValue.localeCompare(bValue, undefined, {
                numeric: true, // human sorts numbers in the string, e.g. A1, A2, A10, A20
                sensitivity: 'base', // accounts for special characters e.g. å,é,è
            });
        };

        return [...items].sort(sortByKey);
    }
}

type KeysOfType<Item, Value> = {
    [K in keyof Item]: Item[K] extends Value ? K : never;
}[keyof Item];
